function toggleDescription(index) {
    let descriptions = document.querySelectorAll('.nasty-description');
    let allItems = document.querySelectorAll('.nasty-item');
    let mobileDescription = document.createElement('div');

    mobileDescription.className = 'mobile-description';
    mobileDescription.id = 'mobile-desc';

    // Get the selected description content
    let selectedDesc = descriptions[index].innerHTML;
    mobileDescription.innerHTML = selectedDesc;

    // Remove any existing mobile descriptions
    document.querySelectorAll('.mobile-description').forEach((el) => el.remove());

    // Remove active class from all items
    allItems.forEach((item) => item.classList.remove('active'));

    if (window.innerWidth <= 768) {
      if (index === 0 || index === 1) {
        allItems[1].insertAdjacentElement('afterend', mobileDescription);
      } else {
        allItems[3].insertAdjacentElement('afterend', mobileDescription);
      }
      allItems[index].classList.add('active'); // Add active class to clicked item
    } else {
      // Desktop: Show description below each image
      descriptions.forEach((desc, i) => {
        if (i === index) {
          desc.style.display = 'block';
          desc.parentElement.classList.add('active'); // Add active class to the parent
        } else {
          desc.style.display = 'none';
          desc.parentElement.classList.remove('active'); // Remove active class from other parents
        }
      });
    }
  }